import { useQuery } from 'react-query';

import * as geoApi from '@/services/Geo/request';

export const EXPANSION_REQUEST_QUERY_KEY = 'geo-expansion-request';

// Chave da fila (`GET expansion-requests/?status=&host=&page=`). Mora aqui, ao
// lado da chave do detalhe, para as mutações da decisão invalidarem a lista
// que a fatia 04 monta sobre `[EXPANSION_REQUESTS_QUERY_KEY, filtros]`.
export const EXPANSION_REQUESTS_QUERY_KEY = 'geo-expansion-requests';

const isNotFound = (error: unknown): boolean =>
  (error as { statusCode?: number } | null)?.statusCode === 404;

/**
 * Detalhe de um pedido de ampliação. `id` nulo (rota sem número) não consulta
 * a API. 404 vira `notFound` sem retry — um link do Slack para pedido apagado
 * não deve ficar "carregando" enquanto o react-query insiste; os demais erros
 * seguem o default da app (uma nova tentativa) e a tela oferece "Tentar de
 * novo" via `refetch`.
 */
export function useExpansionRequest(id: number | null) {
  const query = useQuery(
    [EXPANSION_REQUEST_QUERY_KEY, id],
    () => geoApi.getExpansionRequest(id as number),
    {
      enabled: id !== null,
      staleTime: 30_000,
      retry: (failureCount, error) => !isNotFound(error) && failureCount < 1,
    },
  );

  return { ...query, notFound: query.isError && isNotFound(query.error) };
}
